import { render } from "./SkillSet.vue?vue&type=template&id=24471d90&scoped=true"
const script = {}

import "./SkillSet.vue?vue&type=style&index=0&id=24471d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24471d90"]])

export default __exports__